import {
  Glass,
  PillChip,
  Dot,
  ScreenLabel,
  DisplayText,
  BodyText,
  alpha,
  borderAlpha,
} from "../../components/mobile/primitives";

export const WEEK_DAYS = ["M", "T", "W", "T", "F", "S", "S"];
export const MOOD_WEEK = [7, 6, 9, null, 8, 7, 8]; // null = missed

export const MOOD_LOGS = [
  { date: "Today", value: 8, note: "Good energy, clear head" },
  { date: "Yesterday", value: 7, note: "Bit tired after late call" },
  { date: "Feb 28", value: 9, note: "Post-workout, feel great" },
  { date: "Feb 27", value: 6, note: "Headache mid-afternoon" },
  { date: "Feb 25", value: 7, note: "" },
];

export function TrackerLogsScreen() {
  const ACCENT = "var(--color-kin-lavender)";
  const logged = MOOD_WEEK.filter(Boolean).length;
  const avg = (MOOD_WEEK.filter(Boolean).reduce((s, v) => s + v, 0) / logged).toFixed(1);

  return (
    <div style={{ padding: "8px 16px 16px", display: "flex", flexDirection: "column", gap: 14 }}>
      <DisplayText
        size={28}
        color="var(--color-kin-black)"
        lineHeight={1.1}
        style={{ paddingLeft: 4 }}
      >
        Trackers
      </DisplayText>

      {/* Tracker tabs */}
      <div
        className="phone-scroll"
        style={{ display: "flex", gap: 6, paddingLeft: 4, overflowX: "auto" }}
      >
        {[
          ["Mood", true, ACCENT],
          ["Diet", false, "var(--color-kin-gold-dark)"],
          ["Headache", false, "var(--color-kin-rose)"],
        ].map(([l, a, c]) => (
          <PillChip key={l} active={a} color={c}>
            {l}
          </PillChip>
        ))}
      </div>

      {/* This week */}
      <Glass style={{ padding: "14px 16px", borderRadius: 24 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 14,
          }}
        >
          <ScreenLabel style={{ letterSpacing: "0.15em" }}>This week</ScreenLabel>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <Dot color={ACCENT} size={8} style={{ boxShadow: `0 0 6px ${alpha(ACCENT, "80")}` }} />
            <BodyText size={10} color={ACCENT} weight={800}>
              Streak · 4 days
            </BodyText>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {WEEK_DAYS.map((d, i) => {
            const v = MOOD_WEEK[i];
            const filled = v != null;
            return (
              <div
                key={i}
                style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    background: filled ? ACCENT : "rgba(254,253,251,0.5)",
                    border: filled ? "none" : "1.5px solid rgba(0,0,0,0.05)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: filled ? `0 4px 10px -2px ${alpha(ACCENT, "80")}` : "none",
                  }}
                >
                  {filled && (
                    <BodyText size={11} color="var(--color-kin-white)" weight={800}>
                      {v}
                    </BodyText>
                  )}
                </div>
                <BodyText size={9} color="var(--color-kin-muted)" weight={700}>
                  {d}
                </BodyText>
              </div>
            );
          })}
        </div>
      </Glass>

      {/* Stats row */}
      <div style={{ display: "flex", gap: 8 }}>
        <Glass style={{ flex: 1, padding: "12px 6px", textAlign: "center", borderRadius: 20 }}>
          <DisplayText size={24} color={ACCENT}>
            {avg}
          </DisplayText>
          <ScreenLabel style={{ letterSpacing: "0.15em", marginTop: 2 }}>Avg mood</ScreenLabel>
        </Glass>
        <Glass style={{ flex: 1, padding: "12px 6px", textAlign: "center", borderRadius: 20 }}>
          <DisplayText size={22} color="var(--color-kin-black)">
            {logged}/7
          </DisplayText>
          <ScreenLabel style={{ letterSpacing: "0.15em", marginTop: 2, lineHeight: 1.35 }}>
            Days logged
          </ScreenLabel>
        </Glass>
        <Glass style={{ flex: 1, padding: "12px 6px", textAlign: "center", borderRadius: 20 }}>
          <DisplayText size={24} color="var(--color-kin-black)">
            14
          </DisplayText>
          <ScreenLabel style={{ letterSpacing: "0.15em", marginTop: 2 }}>Day goal</ScreenLabel>
        </Glass>
      </div>

      {/* Log entries */}
      <div>
        <ScreenLabel
          style={{ display: "block", marginBottom: 8, paddingLeft: 4, letterSpacing: "0.15em" }}
        >
          Recent
        </ScreenLabel>
        <Glass style={{ padding: "4px 16px", borderRadius: 24 }}>
          {MOOD_LOGS.map((log, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 0",
                borderBottom: i < MOOD_LOGS.length - 1 ? "1px solid rgba(0,0,0,0.04)" : "none",
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 14,
                  flexShrink: 0,
                  background: alpha(ACCENT, "15"),
                  border: borderAlpha(ACCENT, "30"),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DisplayText size={16} color={ACCENT}>
                  {log.value}
                </DisplayText>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <BodyText size={11} color="var(--color-kin-black)" weight={700}>
                  {log.date}
                </BodyText>
                {log.note && (
                  <BodyText
                    size={9.5}
                    color="var(--color-kin-muted)"
                    weight={500}
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "block",
                      marginTop: 2,
                    }}
                  >
                    {log.note}
                  </BodyText>
                )}
              </div>
            </div>
          ))}
        </Glass>
      </div>
    </div>
  );
}
